import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "exportBox" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "videoBox" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "Topp" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("生成发布文案")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("下载视频")
const _hoisted_8 = {
  key: 1,
  class: "exportTwo"
}
const _hoisted_9 = { class: "dlBtnBox" }
const _hoisted_10 = { class: "dlBox" }
const _hoisted_11 = { class: "videoBoxTwo" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "butValue" }
const _hoisted_14 = { class: "textBtn" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("重新生成 "),
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-shuaxin" })
], -1)
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "btnBox" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("下载视频")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("复制文案")

import useClipboard from "vue-clipboard3";
import {
  ref,
  watch,
  watchEffect,
  onMounted,
  nextTick,
} from "vue";
import { ElMessage } from "element-plus";
import request from "@/api/httpDown";
import Api from "@/api";

export default /*#__PURE__*/_defineComponent({
  props: {
  exchange: {
    type: Boolean,
    default: false,
  },
  detail: {
    type: Object,
    // eslint-disable-next-line vue/require-valid-default-prop
    default: {},
  },
  shop: {
    type: Object,
    // eslint-disable-next-line vue/require-valid-default-prop
    default: {},
  },
},
  emits: ["upProps"],
  setup(__props, { emit }) {

const props = __props
const videoOne = ref(null);
const videotwo = ref(null);




const textShowBtn = ref(false); //!
const ask = ref("");
const countNum = ref("");
const Copywriting = ref("");
const timer = ref(null);
const setTimer = ref(null);

const closeFn = () => {
  test();
  //    textShowBtn.value = false;
  // // videotwo.value.pause();
  // videoOne.value.pause();
  // // videoOne
  // //     video.value.pause();
  // if(textShowBtn.value===false){
  //      videoOne.value.pause();
  // }else{
  //    videotwo.value.pause();
  // }
  emit("upProps", false);
  clearInterval(setTimer.value);
  setTimer.value = null;
  countNum.value = "";
  textShowBtn.value = false;
};
const isDisabled = ref(true);
const arr = ref([]);
const videoUser = ref({});

const test = async () => {
  await nextTick();
  if (textShowBtn.value === false) {
    videoOne.value.pause();
  } else {
    videotwo.value.pause();
  }
};

watchEffect(() => {
  if (!props.exchange) {
    Copywriting.value = "";
  }
});
watch(
  () => props.detail,
  (newValue) => {
    videoUser.value = newValue;
    arr.value = [];
    arr.value.push(newValue._id);
    countNum.value = "";
    Copywriting.value = "";
  }
);

// 使用插件
const { toClipboard } = useClipboard();
const copy = async (msg: string) => {
  timer.value = null;
  try {
    // 复制
    await toClipboard(msg);
    // 复制成功
    ElMessage({
      message: "复制成功",
      type: "success",
    });
  } catch (e) {
    // 复制失败
    ElMessage({
      message: "复制失败",
      type: "error",
    });
  }
};
// 点击复制

function touchCopy() {
  // timer.value = null;
  // 调用
  let value = "";
  let replacements = [{ target: "</br>", replacement: "" }];

  for (let i = 0; i < replacements.length; i++) {
    let regex = new RegExp(replacements[i].target, "g");

    value = Copywriting.value.replace(regex, replacements[i].replacement);
  }

  // let value=Copywriting.value.replace('</br>', '');

  copy(value);
}
const textBtn = async () => {
  clearInterval(setTimer.value);
  // videoOne.value.pause();

  Copywriting.value = "";
  countNum.value = "";
  isDisabled.value = true;

  //点击发布文案
  textShowBtn.value = true;
  let result = await Api.Article.upLoadAi(
    "ai_product_video_assistant_douyin",
    props.detail._id
  );

  ask.value = result.data.id;

  setTimer.value = setInterval(() => {
    // eslint-disable-next-line no-use-before-define
    getTextValue(); //获取文案
  }, 500);
};

//获取文案
const getTextValue = async () => {
  countNum.value = "";
  isDisabled.value = true;
  let replacements = [{ target: "\n", replacement: "</br>" }];
  let replacedText = "";

  let result = await Api.Article.getTextValue(ask.value);

  if (result.data) {
    if (result.data.isFinish == false) {
      replacedText = result.data.content;

      for (let i = 0; i < replacements.length; i++) {
        let regex = new RegExp(replacements[i].target, "g");

        replacedText = replacedText.replace(regex, replacements[i].replacement);
      }
      replacedText = replacedText.replace(/#/, "</br>#");
      Copywriting.value = replacedText;
    } else {
      // setTimer.value = null;
      clearInterval(setTimer.value);
      replacedText = result.data.content;
      for (let i = 0; i < replacements.length; i++) {
        let regex = new RegExp(replacements[i].target, "g");

        replacedText = replacedText.replace(regex, replacements[i].replacement);
      }
      replacedText = replacedText.replace(/#/, "</br>#");
      Copywriting.value = replacedText;
      countNum.value = replacedText.length;
      isDisabled.value = false;
    }

    // let result.
    //   Copywriting.value = result.data.content;
  }
  // else {
  //     Copywriting.value = '';
  // }
};
const updataTitle = () => {
  textBtn();
};

//视频生成结果下载
const downVideText = async () => {
  ElMessage({
    dangerouslyUseHTMLString: true,
    type: "warning",
    message: "<p>正在下载</p>",
    duration: 1000,
  });

  await request
    .get("/api/cemeta/aimanager/v1/video/result/download", {
      params: { videoId: arr.value, type: "video_assistant_download_video" },
    })
    .then((response) => {
      // 从响应头中获取文件名
      const contentDisposition = response.headers["content-disposition"];
      // const filenameMatch = contentDisposition.match(/filename="(.+)"/);
      let filename = contentDisposition.split("=")[1];
      // 创建一个兼容不同浏览器的 URL 对象
      const url = window.URL.createObjectURL(new Blob([response.data]));

      // 创建一个<a>标签，并设置其下载属性和链接
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute("download", filename);

      // 在DOM中模拟点击下载链接
      document.body.appendChild(link);
      link.click();

      // 清理URL对象
      window.URL.revokeObjectURL(url);

      if (videoUser.value?.result?.video) {
        request.post("/api/cemeta/aimanager/v1/video/download", {
          resourceId: props.shop.nameArr.id,
          videoUrlList: [videoUser.value?.result?.video],
        });
      }
    });
  ElMessage({
    dangerouslyUseHTMLString: true,
    type: "success",
    message: "<p>下载完成</p>",
    duration: 1000,
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: props.exchange,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (props.exchange = $event)),
      onClose: closeFn
    }, {
      default: _withCtx(() => [
        (textShowBtn.value == false)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("video", {
                  class: "videoP",
                  ref: (_value, _refs) => {
                    _refs['videoOne'] = _value
                    videoOne.value = _value
                  },
                  autoplay: "",
                  controls: "",
                  src: videoUser.value.result?.video
                }, null, 8, _hoisted_4)
              ]),
              _createElementVNode("p", _hoisted_5, [
                _createVNode(_component_el_button, {
                  onClick: textBtn,
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  onClick: downVideText,
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                })
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("video", {
                      class: "videoP",
                      ref: (_value, _refs) => {
                        _refs['videotwo'] = _value
                        videotwo.value = _value
                      },
                      autoplay: "",
                      controls: "",
                      src: videoUser.value.result?.video
                    }, null, 8, _hoisted_12)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("p", null, _toDisplayString(countNum.value ? "共" + countNum.value + "字" : "正在统计"), 1),
                      _createVNode(_component_el_button, {
                        disabled: isDisabled.value,
                        onClick: updataTitle,
                        class: "resBtn"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_15
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    (Copywriting.value !== '')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "titleValue",
                          innerHTML: Copywriting.value
                        }, null, 8, _hoisted_16))
                      : (_openBlock(), _createElementBlock("div", _hoisted_17, "正在生成文案。。。"))
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_el_button, {
                    onClick: downVideText,
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_19
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    onClick: touchCopy,
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_20
                    ]),
                    _: 1
                  })
                ])
              ])
            ]))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})